
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_URL from "../../services/api";
import "./Checkout.css";

const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const buyNow = location.state?.buyNow || false;

  const [cart, setCart] = useState(location.state?.cart || []);

  const user = JSON.parse(localStorage.getItem("user"));

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
    paymentMethod: "Cash on Delivery",
  });

  useEffect(() => {
    if (user) {
      setForm((prev) => ({
        ...prev,
        name: user.name || "",
      }));
    }
  }, []);

  const total = cart.reduce(
    (sum, item) => sum + Number(item.price) * Number(item.quantity),
    0
  );

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const placeOrder = async () => {
    if (!user) {
      return alert("Please login first.");
    }

    if (!form.name || !form.phone || !form.address) {
      return alert("Please complete all fields.");
    }

    if (cart.length === 0) {
      return alert("Your cart is empty.");
    }

    try {
      const res = await fetch(`${API_URL}/api/orders/place`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: user.user_id,
          delivery_address: form.address,
          phone: form.phone,
          payment_method: form.paymentMethod,
          total_amount: total,
          items: cart,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        return alert(data.message || "Unable to place order.");
      }

      alert("Order placed successfully!");

      // Clear database cart only for normal cart checkout
      if (!buyNow) {
        await fetch(`${API_URL}/api/cart/clear/${user.user_id}`, {
          method: "DELETE",
        });
      }

      setCart([]);

      navigate("/user/books");
    } catch (err) {
      console.log("ORDER ERROR:", err);
      alert("Server Error");
    }
  };

  return (
    <div className="checkout-container">

      {/* PAGE HEADER */}
      <div className="checkout-header">
        <h1>Checkout</h1>
        <p>Complete your delivery details and place your order.</p>
      </div>

      {/* CHECKOUT CONTENT */}
      <div className="checkout-layout">

        {/* LEFT SIDE */}
        <div className="checkout-card">

          <h2 className="checkout-section-title">
            Delivery Details
          </h2>

          <div className="form-group">
            <label>Name</label>

            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter your name"
              className="checkout-input"
              required
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>

            <input
              name="phone"
              type="tel"
              value={form.phone}
              onChange={handleChange}
              placeholder="Enter phone number"
              className="checkout-input"
              required
            />
          </div>

          <div className="form-group">
            <label>Delivery Address</label>

            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Enter complete delivery address"
              className="checkout-textarea"
              required
            />
          </div>

          <div className="form-group">
            <label>Payment Method</label>

            <select
              name="paymentMethod"
              value={form.paymentMethod}
              onChange={handleChange}
              className="checkout-input"
            >
              <option value="Cash on Delivery">
                Cash on Delivery
              </option>
            </select>
          </div>

          <div className="payment-note">
            <span>💵</span>

            <div>
              <strong>Cash on Delivery</strong>
              <p>
                Pay for your order when your books are delivered.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="order-summary-card">

          <h2 className="checkout-section-title">
            Order Summary
          </h2>

          {cart.length === 0 ? (
            <div className="empty-order">
              <div className="empty-order-icon">🛒</div>

              <h3>Your cart is empty</h3>

              <p>
                Add some books before proceeding to checkout.
              </p>

              <button
                className="continue-shopping-btn"
                onClick={() => navigate("/user/books")}
              >
                Browse Books
              </button>
            </div>
          ) : (
            <>
              <div className="order-items">

                {cart.map((item, index) => (
                  <div
                    key={item.book_id || item.id || index}
                    className="order-book"
                  >

                    <div className="order-book-info">

                      <h4>{item.title}</h4>

                      <p>{item.author}</p>

                      <span>
                        Qty: {item.quantity}
                      </span>

                    </div>

                    <div className="order-book-price">
                      Rs.{" "}
                      {(
                        Number(item.price) *
                        Number(item.quantity)
                      ).toFixed(2)}
                    </div>

                  </div>
                ))}

              </div>

              <div className="order-total">

                <span>Total</span>

                <strong>
                  Rs. {total.toFixed(2)}
                </strong>

              </div>

              <button
                className="place-order-btn"
                onClick={placeOrder}
              >
                Place Order
              </button>

              <button
                className="back-shopping-btn"
                onClick={() => navigate("/user/books")}
              >
                Continue Shopping
              </button>

            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default Checkout;
